var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('VuePhoneNumberInput',{attrs:{"color":"#00B9E8","error-color":"#EA5455","error":!!_vm.errors,"countriesHeight":25,"default-country-code":_vm.phoneCode ?? 'US'},on:{"update":_vm.setValue},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }